import styled from 'styled-components';

export const SliderWrapper = styled.div`
  width: 80%;
  height: 3rem;
  margin: 1.5rem auto;
  border: none;
  display: block;
  position: relative;

  @media (min-width: 36rem) {
    max-width: 36rem;
  }

  @media (min-width: 48rem) {
    max-width: 48rem;
  }

  @media (min-width: 75rem) {
    max-width: 75rem;
  }
`;

export const SliderThumb = styled.div`
  position: relative;
  outline: none;
  cursor: pointer;

  &:before {
    content: '';
    height: 1.9rem;
    width: 2rem;
    background-color: #1b7bdd;
    clip-path: polygon(90% 0, 10% 0, 50% 100%);
    top: 120%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
  }

  &:after {
    content: '';
    height: 1.5rem;
    width: 1.6rem;
    clip-path: polygon(90% 0, 10% 0, 50% 100%);
    position: absolute;
    background-color: #f2f2f2;
    top: 130%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const SliderMark = styled.span`
  color: #000;
  font-size: 0.875rem;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular ')};
  transform: translateY(300%);

  @media (min-width: 36rem) {
    font-size: 1.875rem;
    transform: translate(-35%, 305%);
  }

  @media (min-width: 75rem) {
    transform: translate(-35%, 320%);
    font-size: 2.5rem;
  }
`;

export const SliderTrail = styled.div`
  width: 99.25%;
  height: 1px;
  position: absolute;
  top: 85%;
  left: 0;
  transform: translateY(-15%);
  background-color: #000;

  &:before {
    content: '';
    height: 0.5rem;
    width: 0.5rem;
    border-radius: 50%;
    background-color: #000;
    position: absolute;
    left: 0;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
  }

  &:after {
    content: '';
    height: 0.5rem;
    width: 0.5rem;
    border-radius: 50%;
    background-color: #000;
    position: absolute;
    left: 100%;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;
